export default "__VITE_ASSET__BVGi19JB__"